import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = () => ({
  root: {
    display: "flex"
  }
});

class App extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>SISTEMA DE APROVAÇÃO DE FATURAMENTO</div>
    );
  }
}

export default withStyles(styles)(App);
